module.exports = __webpack_public_path__ + "static/location-d9d83842ed72f0c31dee09b2ce9d6751.svg";